/* eslint-disable */
import api from '@/services/api';

export default {
  async fetchEstoque({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    return api.get('/estoque', { params })
      .then(response => response.data)
      .then(data => {
        commit('SET_ESTOQUE', data.registros.data);
        commit('paginacao/SET_PAGINADOR', data.registros, { root: true });
        dispatch('toggleLoading', false, { root: true });
      });
  },

  async fetchDetalhesLote(context, numeroLote) {
    return api.get(`/estoque/lote/${numeroLote}`)
      .then(response => response.data);
  },

  async salvarEstoqueMinimo({ dispatch }, payload) {
    if (payload._id) {
      delete payload.updatedAt;
      delete payload.createdAt;
    }
    return await api.post('/estoque/notificacao/estoqueMinimo/', {
      ...payload,
    });

  },

  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },

  async prepararExcelEstoque() {
    const { data } = await api.get('/estoque/excel');

    return data;
  }
}
